import { render, staticRenderFns } from "./VehicleReestr.vue?vue&type=template&id=eb10e226&"
import script from "./VehicleReestr.vue?vue&type=script&lang=js&"
export * from "./VehicleReestr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports